import { ALL_LNGS_NAMESPACES } from '@ingenico/util-i18n-config';
import { useMediaQuery } from '@mui/system';
import { useTranslation } from 'react-i18next';

export function useSyncConfigurationPageVM() {
  const { t } = useTranslation([ALL_LNGS_NAMESPACES.COMMON]);

  const pageTitle = t('navigation.page.syncConfiguration', { ns: ALL_LNGS_NAMESPACES.COMMON });
  const isMobile = useMediaQuery('(max-width: 766px)');

  return { pageTitle, isMobile };
}
